import * as React from 'react';
import { Button, DialogActions, DialogContent, DialogTitle, Typography, Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { withRouter } from '../common/with-router';
import { adultGenders } from '../common/genders';

function EditSex(props) {
  const [gender, setGender] = React.useState(props.mouse.gender);

  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };

  const handleSubmit = () => {
    const data = {
      gender: gender
    };
    props.onSubmit(data);
    props.onClose();
  };

  return (
    <>
      <DialogTitle>Edit Mouse Sex</DialogTitle>
      <DialogContent>
        <Box sx={{ p: 2 }}>
          <Typography variant="body1" gutterBottom>
            Mouse ID: {props.mouse.id}
          </Typography>
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel>Sex</InputLabel>
            <Select
              value={gender}
              onChange={handleGenderChange}
              label="Sex"
            >
              {adultGenders.map((gender, index) => (
                <MenuItem key={index} value={gender}>
                  {gender === 'M' ? 'Male' : 'Female'}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>Cancel</Button>
        <Button onClick={handleSubmit}>Submit</Button>
      </DialogActions>
    </>
  );
}

export default withRouter(EditSex); 